import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { createContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { getTestManager } from '@uniformdev/personalize';
import { getSitecorePersonalizationManager } from '@uniformdev/personalize';
import { getSitecoreEsiPersonalizationManager } from '@uniformdev/personalize';
import { getNullLogger } from '@uniformdev/common';
import { UniformCookieNames, getMaxExpirationDate } from '@uniformdev/tracking';
export var SitecorePersonalizationContext = createContext({});
function getTestManagerFromCookie(id, cookies, setCookie, deleteCookie, props, logger) {
  var _a;
  var contextData = props.contextData,
    disabled = props.disabled;
  var getValue = function getValue(settings) {
    if (!cookies) return;
    var cookie = cookies[UniformCookieNames.Testing];
    if (!cookie) return;
    var parts = cookie.split("|");
    if (parts.length != 2) return;
    if (parts[0] != settings.id) return;
    return parts[1] === '1';
  };
  var testStateManager = {
    getIsTestingStateKnown: function getIsTestingStateKnown(settings) {
      return getValue(settings) != undefined;
    },
    getIsIncludedInTest: function getIsIncludedInTest(settings) {
      if (cookies) {
        var value = getValue(settings);
        return value == true;
      }
      return false;
    },
    setIsIncludedInTest: function setIsIncludedInTest(value, settings) {
      if (settings === null || settings === void 0 ? void 0 : settings.id) {
        var value2 = "".concat(settings.id, "|").concat(value);
        setCookie(UniformCookieNames.Testing, value2, {
          path: "/",
          expires: getMaxExpirationDate()
        });
      }
    },
    setTestNotRunning: function setTestNotRunning() {
      if (cookies[UniformCookieNames.Testing]) {
        logger.debug("Sitecore personalization context -   * No personalization test is running so delete the testing cookie.", {
          cookie: cookies[UniformCookieNames.Testing]
        });
      }
      deleteCookie(UniformCookieNames.Testing);
    }
  };
  var testSettingsSource = "props";
  var testSettings = props.testSettings;
  if (!testSettings) {
    testSettingsSource = "context data";
    testSettings = (_a = contextData === null || contextData === void 0 ? void 0 : contextData.testing) === null || _a === void 0 ? void 0 : _a.data;
  }
  logger.debug("Sitecore personalization context -   * Using personalization test settings from ".concat(testSettingsSource, "."), {
    testSettings: testSettings,
    props: props,
    contextData: contextData
  });
  var args = {
    testSettings: testSettings !== null && testSettings !== void 0 ? testSettings : [],
    testStateManager: testStateManager,
    options: {
      disabled: disabled,
      logger: logger
    }
  };
  return getTestManager(id, args);
}
function getPersonalizationManager(props, args, logger) {
  var _props$personalizatio = props.personalizationMode,
    personalizationMode = _props$personalizatio === void 0 ? 'default' : _props$personalizatio,
    _props$sitecoreApiKey = props.sitecoreApiKey,
    sitecoreApiKey = _props$sitecoreApiKey === void 0 ? '' : _props$sitecoreApiKey,
    _props$sitecoreSiteNa = props.sitecoreSiteName,
    sitecoreSiteName = _props$sitecoreSiteNa === void 0 ? '' : _props$sitecoreSiteNa;
  logger.debug("Sitecore personalization context -   * Getting personalization manager based on personalization mode.", {
    personalizationMode: personalizationMode
  });
  if (personalizationMode == 'jss-esi') {
    return getSitecoreEsiPersonalizationManager(Object.assign(Object.assign({}, args), {
      sitecoreApiKey: sitecoreApiKey,
      sitecoreSiteName: sitecoreSiteName
    }));
  }
  return getSitecorePersonalizationManager(args);
}
export var SitecorePersonalizationContextProvider = function SitecorePersonalizationContextProvider(props) {
  var _a;
  var children = props.children,
    contextData = props.contextData,
    contextDataSource = props.contextDataSource,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$logger = props.logger,
    logger = _props$logger === void 0 ? getNullLogger() : _props$logger,
    subscriptions = props.subscriptions;
  var tracking = contextData === null || contextData === void 0 ? void 0 : contextData.tracking;
  var itemId = (_a = tracking === null || tracking === void 0 ? void 0 : tracking.item) === null || _a === void 0 ? void 0 : _a.id;
  //
  //Create test manager.
  var _useCookies = useCookies([]),
    _useCookies2 = _slicedToArray(_useCookies, 3),
    cookies = _useCookies2[0],
    setCookie = _useCookies2[1],
    deleteCookie = _useCookies2[2];
  //
  //Create personalization manager.
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    personalizationManager = _useState2[0],
    setPersonalizationManager = _useState2[1];
  useEffect(function () {
    if (!itemId) return;
    logger.debug("Sitecore personalization context - START EFFECT: Item id changed.", {
      itemId: itemId
    });
    var testManager = getTestManagerFromCookie("PERS_CONTEXT_TEST_MGR", cookies, setCookie, deleteCookie, props, logger);
    if (!testManager) {
      logger.debug("Sitecore personalization context -   * No test manager was resolved from cookie.", {
        cookies: Object.assign({}, cookies)
      });
    } else {
      logger.debug("Sitecore personalization context -   * Test manager was resolved from cookie.", {
        id: testManager.id
      });
    }
    var args2 = {
      contextData: contextData,
      contextDataSource: contextDataSource,
      disabled: disabled,
      logger: logger,
      testManager: testManager
    };
    //
    //   
    var manager = getPersonalizationManager(props, args2, logger);
    if (!manager) {
      logger.debug("Sitecore personalization context -   * No personalization manager was resolved.", {
        props: props,
        args: args2
      });
      setPersonalizationManager(function () {
        return undefined;
      });
    } else {
      logger.debug("Sitecore personalization context -   * Personalization manager was resolved.", {
        id: manager.id
      });
      if (!subscriptions) {
        logger.debug("Sitecore personalization context -   * No subscriptions are set on props, so no subscriptions will be added to personalization manager.", {
          props: props
        });
      } else {
        logger.debug("Sitecore personalization context -   * Adding subscriptions from props to personalization manager.", {
          manager: manager.subscriptions.id,
          props: props,
          subscriptionTypes: manager.subscriptions.getSubscriptionTypes()
        });
        subscriptions(manager.subscriptions.subscribe);
      }
      logger.debug("Sitecore personalization context -   * Personalization manager set in state on the context.", {
        id: manager === null || manager === void 0 ? void 0 : manager.id,
        manager: manager === null || manager === void 0 ? void 0 : manager.subscriptions.id,
        props: props,
        args2: args2
      });
      setPersonalizationManager(function () {
        return manager;
      });
    }
    logger.debug("Sitecore personalization context - END EFFECT: Item id changed.");
  }, [itemId]);
  //
  //
  var value = {
    item: personalizationManager === null || personalizationManager === void 0 ? void 0 : personalizationManager.page,
    logger: logger,
    personalizationManager: personalizationManager,
    timestamp: 0
  };
  return React.createElement(SitecorePersonalizationContext.Provider, {
    value: value
  }, children);
};